import { action, thunk } from 'easy-peasy'

import { getSavedPaymentCardApi } from 'services/payment'

const _states = {
  isSelectedPayment: false,
  method: null, // CREDIT_CARD | MOBILE_BANKING | COUNTER_SERVICE_OR_ATM | INSTALLMENT
  creditCard: {
    name: null,
    type: null,
    accountNumber: null,
    encryptedAccountInformation: null,
  },
  savedPaymentCards: [],
  selectedHistoryCardId: null,
}

const _actions = {
  reset: action(() => {
    return {
      ..._states,
    }
  }),
  setMethod: action((state, payload) => {
    state.method = payload
  }),
  setCreditCard: action((state, payload) => {
    state.creditCard = payload
    state.isSelectedPayment = true
  }),
  setIsSelectedPayment: action((state, payload) => {
    state.isSelectedPayment = payload
  }),
  setSavedPaymentCards: action((state, payload) => {
    state.savedPaymentCards = payload
  }),
  setSelectedHistoryCardId: action((state, payload) => {
    state.selectedHistoryCardId = payload
  }),
}

const _thunks = {
  getSavedPaymentCard: thunk(async (actions, payload, { getStoreState }) => {
    const profile = getStoreState()?.auth?.profile

    const stakeholderId = profile?.stakeholderId

    return await getSavedPaymentCardApi(stakeholderId)
      .then(res => res.data.data)
      .then(data => {
        actions.setSavedPaymentCards(data)

        return data
      })
  }),
}

const paymentModal = {
  ..._states,
  ..._actions,
  ..._thunks,
}

export default paymentModal
